import getConfig from 'next/config';
import React from 'react';

interface searchTitleProps {
  searchTitle: string;
}
const SrpSchema: React.FC<searchTitleProps> = (props) => {
  const { publicRuntimeConfig } = getConfig();
  const baseUrl = publicRuntimeConfig.baseUrl;
  const { searchTitle } = props;
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'website',
    'name': 'thinkofliving.com',
    'url': 'https://thinkofliving.com/',
    'potentialAction': {
      '@type': 'SearchAction',
      'target': `${baseUrl}list/${searchTitle}`,
      'query-input': searchTitle,
    },
    'image': {
      '@type': 'ImageObject',
      'url':
        'https://cdn-assets.prod.thinkofliving.com/_next/static/images/tol-logo-text-7f98a1ca4e741f5e61ef43ea8e9d5144.jpg',
      'width': '1200',
      'height': '800',
    },
    'sameAs': [
      'https://www.youtube.com/user/thinkofliving',
      'https://www.facebook.com/ThinkOfLiving/',
      'https://twitter.com/thinkofliving',
      'https://www.instagram.com/thinkofliving/',
    ],
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
};

export default SrpSchema;
